import { render, staticRenderFns } from "./GeoMobyEmbed.vue?vue&type=template&id=1d89f93e&scoped=true&"
import script from "./GeoMobyEmbed.vue?vue&type=script&lang=ts&"
export * from "./GeoMobyEmbed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89f93e",
  null
  
)

export default component.exports